import "./FloatingActions.scss";
import { useState } from "react";
import { MdStarBorder } from "react-icons/md";
import { Button } from "../Button/Button";
import { ButtonFrameworkVariant } from "../ButtonFramework/ButtonFramework";
import LLMPanel from "../../LLM/LLMPanel/LLMPanel";
import VideoTutorialTray from "../../VideoTutorial/VideoTutorialTray";
import { VideoInfo } from "../../VideoTutorial/videoTutorialUtils";

enum FloatingActionsState {
  BUTTON = "button",
  MENU = "menu",
  TUTORIALS = "tutorials",
  JIRA = "jira",
  LLM = "llm",
}

const menuOptions = [
  FloatingActionsState.TUTORIALS,
  FloatingActionsState.JIRA,
  FloatingActionsState.LLM,
];

interface FloatingActionsProps {
  videoList: VideoInfo[] | undefined;
}

const FloatingActions = ({ videoList }: FloatingActionsProps): JSX.Element => {
  const [floatingState, setFloatingState] = useState<FloatingActionsState>(
    FloatingActionsState.BUTTON
  );

  const onHide = () => setFloatingState(FloatingActionsState.BUTTON);

  return (
    <div className="floatingActionsContainer">
      <div className="floatingActionsMenu">
        {floatingState === FloatingActionsState.MENU &&
          menuOptions.map(option => (
            <Button
              key={option}
              className="floatingActionsMenuButton"
              onClick={() => setFloatingState(option)}
            >
              {option}
            </Button>
          ))}
        <Button
          className="floatingActionsMainButton"
          onClick={() =>
            setFloatingState(current =>
              current === FloatingActionsState.BUTTON
                ? FloatingActionsState.MENU
                : FloatingActionsState.BUTTON
            )
          }
          icon={<MdStarBorder />}
          variant={ButtonFrameworkVariant.ICON_ONLY}
        />
      </div>
      <VideoTutorialTray
        showVideoTray={floatingState === FloatingActionsState.TUTORIALS}
        setShowVideoTray={show =>
          show ? setFloatingState(FloatingActionsState.TUTORIALS) : onHide()
        }
        videoList={videoList}
      />
      <LLMPanel show={floatingState === FloatingActionsState.LLM} onHide={onHide} />
    </div>
  );
};

export default FloatingActions;
